import React from 'react';

interface FormFieldProps {
  label?: string;
  hint?: string;
  error?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const FormField: React.FC<FormFieldProps> = ({ label, hint, error, required, children, className = '' }) => {
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      {label && (
        <label className="text-xs font-bold uppercase tracking-widest text-slate-500 dark:text-slate-400">
          {label}
          {required && <span className="text-red-500 ms-1">*</span>}
        </label>
      )}
      {children}
      {error ? (
        <div className="text-xs text-red-600 flex items-center gap-1 mt-0.5">
          <span className="material-symbols-outlined text-sm">error</span>
          {error}
        </div>
      ) : hint ? (
        <div className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{hint}</div>
      ) : null}
    </div>
  );
};
